import {useQuery, UseQueryResult} from "@tanstack/react-query";
import {
    IMyCompanyBank
} from "../../../../../../../utils/interfaces/my_company/my_company_registry/my_company_bank/IMyCompanyBank";
import {CustomAxiosError, useApiCalls} from "../../../../../../../logics/api_config";
import {useAuth} from "../../../../../../../utils/contexts/auth-context";


const useApiGetMyCompanyBanks = (): UseQueryResult<IMyCompanyBank[], CustomAxiosError> => {
    const {selectedCompany} = useAuth();

    const {get} = useApiCalls()

    async function doGet(company_token: string | undefined): Promise<IMyCompanyBank[]> {
        try {
            const response = await get(`/api/company/${company_token}/my_company/my_company_registry/bank`);
            return response?.data;
        } catch (error) {
            throw error;
        }
    }

    return useQuery({
        queryKey: ["useApiGetMyCompanyBanks"],
        queryFn: () => doGet(selectedCompany?.company_token,),
    })
};

export default useApiGetMyCompanyBanks